import { fromJS } from 'immutable'
import {
  SHOW_MANUAL_EFFICIENCY,
  CLOSE_MANUAL_EFFICIENCY,
} from './../../constants'

const init = fromJS({
  isFetching: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SHOW_MANUAL_EFFICIENCY:
      return state
        .set('isFetching', true)
        .set('isOpen', true)
    case CLOSE_MANUAL_EFFICIENCY:
      return state
        .set('isFetching', false)
        .set('isOpen', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/efficiency-resource/efficiency-manual-reducer.js